import React from 'react';
import { FadeIn } from './FadeIn';
import { Target, Zap } from 'lucide-react';
export function Mechanism() {
  return <section className="py-24 bg-tactical-dark border-b border-tactical-border relative overflow-hidden" data-id="element-146">
      {/* Background grid */}
      <div className="absolute inset-0 bg-grid-pattern opacity-10" data-id="element-147"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl relative z-10" data-id="element-148">
        <FadeIn data-id="element-149">
          <div className="text-center mb-16" data-id="element-150">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-tactical-accent/10 border border-tactical-accent text-tactical-accent font-mono text-sm uppercase tracking-widest mb-6" data-id="element-151">
              <Target className="w-4 h-4" data-id="element-152" />
              <span data-id="element-153">Mecanismo Único</span>
            </div>
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold uppercase mb-6" data-id="element-154">
              El Sistema de <br data-id="element-155" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-tactical-accent to-blue-500" data-id="element-156">
                Micro-Acciones Obligatorias
              </span>
            </h2>
            <p className="text-xl text-zinc-300 max-w-3xl mx-auto leading-relaxed" data-id="element-157">
              Este protocolo no te pide que cambies tu vida de la noche a la
              mañana. Te obliga a ejecutar acciones quirúrgicas que "engañan" a
              tu cerebro para romper la inercia.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-158">
          <FadeIn delay={0.1} className="bg-tactical-panel border border-tactical-border p-8 flex items-center gap-6" data-id="element-159">
            <div className="text-5xl sm:text-7xl font-mono font-bold text-tactical-accent opacity-80" data-id="element-160">
              &lt;3
            </div>
            <div data-id="element-161">
              <h3 className="font-oswald text-2xl uppercase mb-2" data-id="element-162">
                Minutos por Acción
              </h3>
              <p className="text-zinc-400" data-id="element-163">
                Ejecuciones quirúrgicas tan cortas que tu cerebro no tiene
                tiempo de fabricar excusas.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} className="bg-tactical-panel border border-tactical-border p-8 flex items-center gap-6" data-id="element-164">
            <div className="text-5xl sm:text-7xl font-mono font-bold text-tactical-cta opacity-80" data-id="element-165">
              21
            </div>
            <div data-id="element-166">
              <h3 className="font-oswald text-2xl uppercase mb-2" data-id="element-167">
                Días de Impacto
              </h3>
              <p className="text-zinc-400" data-id="element-168">
                El tiempo exacto para acumular victorias físicas y financieras
                que crean una identidad de ganador.
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} className="text-center" data-id="element-169">
          <div className="inline-flex items-center gap-3 text-zinc-400 font-mono text-sm uppercase bg-zinc-900 px-6 py-3 border border-zinc-800" data-id="element-170">
            <Zap className="w-4 h-4 text-tactical-cta" data-id="element-171" />
            <span data-id="element-172">Es una reprogramación basada en el impulso.</span>
          </div>
        </FadeIn>
      </div>
    </section>;
}